import React, { useEffect, useState } from "react";
import DefaultLayout from "../../../layouts/defaultLayout";
import { search } from "../../../assets/svgIcons";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { userData } from "../../../data/fake_login_data";
import { ToastContainer, toast } from "react-toastify";
import { Loader, Toggle } from "rsuite";
import Modal from "../../../components/modal";

const EnquiryStudents = () => {
  const [searchValue, setSearchValue] = useState(null);
  const [data, setData] = useState(null);
  const [type, setType] = useState(1);
  const [courses, setCourses] = useState(null);
  const [chapters, setChapters] = useState(null);
  const [loading, setLoading] = useState(false);
  const [resetId, setResetId] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        BASE_URL + "students/select_st_profile.php",
        {
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
          student_id: !type
            ? searchValue?.startsWith("2")
              ? searchValue.slice(1, searchValue?.length)
              : searchValue
            : searchValue,
          type: type ? "id" : "phone",
        }
      );

      if (response?.data?.status == "success") {
        setData(response?.data?.message);
      } else toast.error("Student Not Found");
      setLoading(false);
    } catch (err) {
      setData([]);
      toast.error(err?.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    setChapters(
      data?.subscriptions?.filter((item) => item?.sub_type === 'chapter')
    );
    setCourses(
      data?.subscriptions?.filter((item) => item?.sub_type === 'course')
    );
  }, [data]);
  const resetSimCard = async (sim_card) => {
    try {
      const response = await axios.post(
        BASE_URL + "students/update_sim_card.php",
        {
          student_id: data?.student_id,
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
          sim_card: sim_card == 0 ? 1 : 0,
        }
      );
      if (response.data?.status == "success") {
        toast.success(response.data?.message);
        fetchData();
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(response.data?.message);
      }

      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };
  const resetUser = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        BASE_URL + "students/update_serial.php",
        {
          student_id: data?.student_id,
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
        }
      );
      if (response.data?.status == "success") {
        toast.success(response.data?.message);
        fetchData();
        setResetId(false);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(response.data?.message);
      }

      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };
  const hiddenArr = [
    "student_token",
    "student_grade",
    "university_id",
    "student_photo",
    "earphone_permission",
    "all_permission",
    "subscriptions",
    "phone_jack",
  ];
  return (
    <div id="home" className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <DefaultLayout
        children={
          <div className="max-w-9xl mx-auto bg-white rounded-2xl shadow-xl p-8">
            <h4 className="text-2xl font-bold text-indigo-800 mb-6 text-center">Enquiries</h4>
            <div className="flex items-center justify-center gap-4 mb-6">
              <span className="text-lg font-medium text-gray-700">By Student Phone</span>
              <Toggle 
                checked={type} 
                onChange={(e) => setType(e)} 
                className="scale-125"
              />
              <span className="text-lg font-medium text-gray-700">By Student Id</span>
            </div>
            <div className="flex items-center gap-4 mb-8">
              <div className="flex-1 relative">
                <label htmlFor="search" className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                  {search}
                </label>
                <input
                  type="search"
                  id="search"
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                  }}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                  placeholder="Enter student phone or ID..."
                />
              </div>
              <button
                className="px-6 py-3 bg-indigo-600 text-white font-bold rounded-lg shadow-md hover:bg-indigo-700 hover:shadow-lg transition duration-300 transform hover:-translate-y-1 flex items-center justify-center"
                onClick={() =>
                  !loading
                    ? searchValue && searchValue?.length
                      ? fetchData()
                      : toast.error("Enter Value")
                    : null
                }
              >
                {!loading ? "Search" : <Loader />}
              </button>
            </div>
            {data ? (
              <>
                <div className="flex flex-col md:flex-row items-center gap-6 mb-8 bg-indigo-50 p-6 rounded-xl shadow-md">
                  <img
                    src={
                      data?.student_photo && data?.student_photo?.length
                        ? data?.student_photo
                        : 'https://camp-coding.tech/dr_elmatary/profile_icons/1032037.png'
                    }
                    alt="Student"
                    className="w-32 h-32 rounded-full object-cover border-4 border-indigo-500 shadow-lg"
                  />
                  <div className="text-center md:text-left">
                    <h2 className="text-xl font-bold text-indigo-700">
                      {data?.student_name} - {data?.uni_name} - {data?.grade_name}
                    </h2>
                    <p className="text-gray-600">{data?.student_email}</p>
                    <p className="text-gray-600">{data?.student_phone}</p>
                  </div>
                </div>
                <div className="mb-10 overflow-x-auto rounded-lg shadow-md">
                  {data ? (
                    <table className="min-w-full divide-y divide-gray-200">
                      <tbody className="bg-white divide-y divide-gray-200">
                        {data
                          ? Object.keys(data)?.map((item) => {
                              if (
                                !hiddenArr.filter((h_item) => h_item == item)
                                  ?.length
                              )
                                return (
                                  <tr key={item} className="hover:bg-indigo-50 transition duration-200">
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 capitalize">
                                      {item.replace(/_/g, ' ')}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                      <div className="flex items-center gap-4">
                                        {item == "sim_card" ? (
                                          <div className="reset">
                                            <Toggle
                                              checked={data?.sim_card != 0}
                                              onChange={() =>
                                                resetSimCard(data?.sim_card)
                                              }
                                              className="scale-125"
                                            />
                                          </div>
                                        ) : null}
                                        {item == "reset_count" ? (
                                          <button
                                            className="px-4 py-2 bg-red-500 text-white font-bold rounded-md shadow hover:bg-red-600 transition duration-200"
                                            onClick={() => {
                                              setResetId(data);
                                            }}
                                          >
                                            Reset
                                          </button>
                                        ) : null}
                                        <span>{data[item]}</span>
                                      </div>
                                    </td>
                                  </tr>
                                );
                            })
                          : null}
                      </tbody>
                    </table>
                  ) : null}
                </div>
                <h2 className="text-2xl font-bold text-indigo-800 mb-4">Subscription Courses</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
                  {courses && courses?.length ? (
                    courses?.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="bg-white rounded-xl shadow-lg overflow-hidden transition duration-300 hover:shadow-xl hover:scale-105"
                        >
                          <img
                            src={
                              item?.course_details?.course_photo &&
                              item?.course_details?.course_photo?.length
                                ? item?.course_details?.course_photo
                                : 'https://elmatary.com/El_Matary_Platform/platform/admin/images/225557437_1693865054item_img.jpeg'
                            }
                            alt="Course"
                            className="w-full h-40 object-cover"
                          />
                          <div className="p-4">
                            <h5 className="text-lg font-bold text-indigo-700 mb-2">
                              Course: {item?.course_details?.course_name}
                            </h5>
                            <p className="text-sm text-gray-600 mb-4">
                              Subscription date: {item?.date}
                            </p>
                            <button className="w-full px-4 py-2 bg-red-500 text-white font-bold rounded-md shadow hover:bg-red-600 transition duration-200">
                              Cancel Subscription
                            </button>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <h4 className="col-span-3 text-center text-gray-600">No Subscription</h4>
                  )}
                </div>
                <h2 className="text-2xl font-bold text-indigo-800 mb-4">Subscription Chapters</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {chapters && chapters?.length ? (
                    chapters?.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="bg-white rounded-xl shadow-lg overflow-hidden transition duration-300 hover:shadow-xl hover:scale-105"
                        >
                          <img
                            src={
                              item?.chapter_details?.chapter_photo &&
                              item?.chapter_details?.chapter_photo?.length
                                ? item?.chapter_details?.chapter_photo
                                : 'https://elmatary.com/El_Matary_Platform/platform/admin/images/225557437_1693865054item_img.jpeg'
                            }
                            alt="Chapter"
                            className="w-full h-40 object-cover"
                          />
                          <div className="p-4">
                            <h5 className="text-lg font-bold text-indigo-700 mb-2">
                              Chapter: {item?.chapter_details?.chapter_title}
                            </h5>
                            <p className="text-sm text-gray-600 mb-4">
                              Subscription date: {item?.date}
                            </p>
                            <button className="w-full px-4 py-2 bg-red-500 text-white font-bold rounded-md shadow hover:bg-red-600 transition duration-200">
                              Cancel Subscription
                            </button>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <h4 className="col-span-3 text-center text-gray-600">No Subscription</h4>
                  )}
                </div>
              </>
            ) : null}
          </div>
        }
      />
      <Modal
        open={resetId}
        toggle={setResetId}
        headerTitle={"Reset Student"}
        children={
          <>
            <h5 className="text-lg font-semibold text-gray-800 mb-4 text-center">
              {"Are You Sure To Reset User - " + resetId?.student_name + " ?"}
            </h5>
            <div className="flex justify-center gap-4">
              <button
                className="px-6 py-2 bg-red-500 text-white font-bold rounded-lg shadow-md hover:bg-red-600 hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
                onClick={() => {
                  return !loading ? resetUser() : null;
                }}
              >
                {!loading ? "Yes" : <Loader />}
              </button>

              <button
                className="px-6 py-2 bg-indigo-600 text-white font-bold rounded-lg shadow-md hover:bg-indigo-700 hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
                onClick={() => {
                  setResetId(false);
                }}
              >
                No
              </button>
            </div>
          </>
        }
      />
      <ToastContainer />
    </div>
  );
};

export default EnquiryStudents;